import { useAxios } from '@/modules/axios'
import { AxiosInstance, AxiosProgressEvent } from 'axios'
import { Category } from '@/models/Category'
import { Incidencia } from '@/models/Incidencia'
import { IncidenciaAlta } from '@/models/IncidenciaAlta'
import { IncidenciaListRequest } from '@/models/IncidenciaListRequest'
import { IncidenciaItem } from '@/models/IncidenciaItem'
import { FileDownload } from "@/models/FileDownload"
import { useIncidenciaStore } from '@/stores/incidencia-store'

class IvpService {
    private client: AxiosInstance

    constructor () {
        this.client = useAxios()
    }

    async getCategories (): Promise<Category[]> {
        const { data } = await this.client.get('categories')
        return data
    }

    async getIncidencias (request: IncidenciaListRequest): Promise<IncidenciaItem[]> {
        const { data } = await this.client.get('incidencias', { params: request, headers: { 'x-api-version': '2.0' } })

        return data
    }

    async getDocument (id: string) : Promise<FileDownload> {
        const { data } = await this.client.get(`document/${id}`, { headers: { 'x-api-version': '2.0' } })

        return data
    }

    async postIncidencia (incidencia: Incidencia): Promise<IncidenciaAlta> {
        const store = useIncidenciaStore()

        const { data } = await this.client.post('incidencias', incidencia, {
            headers: { 'x-api-version': '2.0' },
            onUploadProgress: (event: AxiosProgressEvent) => {
                const { progress } = event
                if (!progress) return
                store.setProgress(Math.round(progress * 100))
            },
        })

        return data
    }
}

export const ivpService = new IvpService()
